import { createReducer, on } from '@ngrx/store';
import { TreeNode } from 'primeng/api';
import { selectNode, toggleNode, loadProjectLocationSuccess, refreshTree } from './ProjectLocationAction';

export interface ProjectLocationState {
    expandedKeys: { [key: string]: boolean };
    selectedKey?: string;
    projectLocations: TreeNode[];
    loading: boolean;
}

export const initialProjectLocationState: ProjectLocationState = {
    expandedKeys: {},
    selectedKey: undefined,
    projectLocations: [],
    loading: false,
};

export const ProjectLocationReducer = createReducer(
    initialProjectLocationState,
    on(toggleNode, (state, { key, expanded }) => ({
        ...state,
        expandedKeys: { ...state.expandedKeys, [key]: expanded }
    })),
    on(selectNode, (state, { key }) => ({
        ...state,
        selectedKey: key
    })),
    on(loadProjectLocationSuccess, (state, { projectLocations }) => ({
        ...state,
        projectLocations,
        loading: false
    })),
    on(refreshTree, (state) => ({
        ...state,
        loading: true
    })),
    // on(setSelectedStock, (state, { stockId }) => ({
    //     ...state,
    //     selectedStockId: stockId,
    //     divisions: [],
    //     expandedKeys: {},
    //     selectedKey: undefined
    // }))
);
